export default __webpack_public_path__ + "static/media/55.603ddf95.png";